import { Check } from "lucide-react";

function Success() {
    return (
        <main style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.5rem"
        }}> 
            <div style={{
                backgroundColor: "#00ff2a",
                height: "18rem",
                width: "18rem",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Check size={136} color="#fafafa"/>
            </div>
            <p style={{
                fontSize: "2rem",
                color: "#1d121b",
                fontWeight: "600"
            }}>Checklist Assinado!</p>
        </main>
    )
}

export default Success;